import { render, staticRenderFns } from "./FilesNew.vue?vue&type=template&id=678829fa&scoped=true"
import script from "./FilesNew.vue?vue&type=script&lang=js"
export * from "./FilesNew.vue?vue&type=script&lang=js"
import style0 from "./FilesNew.vue?vue&type=style&index=0&id=678829fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678829fa",
  null
  
)

export default component.exports